import type { IFilter } from "../../../../types/models/filter.models.types";
import type { IPagination } from "../../../../types/models/pagination.models.types";
import { useGetHttp } from "../../http.hook";

export interface IFavoriteSocial {
  id: string;
  name: string;
  description: string;
  filter: IFilter;
  createdAt:Date;
  createdBy: {
    accountType: string;
    name: string;
    email: string;
    id: string;
  };
}

interface IResponse {
  favouriteSocials: Array<IFavoriteSocial>;
  pagination: IPagination;
}

export function useGetAllFavoritesAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials",
  });
}
